export default "__VITE_ASSET__D$DY9f4p__"